import React from 'react'
import { ButtonGroup, Stack } from 'react-bootstrap'
import { AddToCartButton } from '../../components/Product/AddToCartButton'
import { MoreInfoButton } from '../../components/Product/MoreInfoButton'
import { HorizontalStack } from '@ztechapps/webui.util'
import { PricePerUom } from '@ztechapps/product.webui'

type ProductActionProps = {
  price: number
  _id: string
  code: string
  orderUom?: { _id: string; name: string; symbol: string }
}

export default function ProductAction({ price, _id, code, orderUom }: ProductActionProps) {
  return (
    <Stack gap={2} className="p-2  ">
      <HorizontalStack className="justify-content-end">
        <div>
          <PricePerUom price={price} uom={orderUom?.name} className="m-0 text-muted" />
        </div>
      </HorizontalStack>

      <HorizontalStack className="justify-content-end">
        <div>
          <ButtonGroup size="sm">
            <AddToCartButton product={{ _id, code }} />
            <MoreInfoButton product={{ _id, code }} />
          </ButtonGroup>
        </div>
      </HorizontalStack>
    </Stack>
  )
}
